import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EmpLayout from '../../Components/EmpScheduleLayout.jsx';
import { Button, Form, Alert } from 'react-bootstrap';
import axios from '../../Authservices/axiosInstance';
import './emps-timing.css';
import Select from 'react-select';

export default function EmpTiming() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [timingData, setTimingData] = useState({
    shiftStart: '',
    shiftEnd: '',
    breakStart: '',
    breakEnd: '',
  });
  const [shift, setShift] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimingData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (timingData.shiftStart) {
      setShift(calculateShift(timingData.shiftStart));
    }
  }, [timingData.shiftStart]);

  const calculateShift = (shiftStart) => {
    const start = new Date(`1970-01-01T${shiftStart}:00`);
    return start.getHours() < 12 ? 'AM' : 'PM';
  };

  const shiftOptions = [
    { value: 'AM', label: 'Morning' },
    { value: 'PM', label: 'Evening' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { shiftStart, shiftEnd, breakStart, breakEnd } = timingData;

    const start = new Date(`1970-01-01T${shiftStart}:00`);
    let end = new Date(`1970-01-01T${shiftEnd}:00`);

    // Handle overnight shift
    if (end <= start) {
      end.setDate(end.getDate() + 1); // Add 1 day to end
    }

    let totalBreakTime = 0;
    if (breakStart && breakEnd) {
      const breakIn = new Date(`1970-01-01T${breakStart}:00`);
      let breakOut = new Date(`1970-01-01T${breakEnd}:00`);

      // Handle overnight break
      if (breakOut <= breakIn) {
        breakOut.setDate(breakOut.getDate() + 1);
      }

      if (breakOut <= breakIn) {
        setAlertMessage('Break-IN time must be before Break-OUT time.');
        setAlertVariant('danger');
        setShowAlert(true);
        return;
      }

      totalBreakTime = breakOut - breakIn;
    }

    const totalWorkHours = (end - start - totalBreakTime) / 3600000;

    if (totalWorkHours <= 0) {
      setAlertMessage('Invalid shift. Check-Out must be after Check-IN.');
      setAlertVariant('danger');
      setShowAlert(true);
      return;
    }

    try {
      const response = await axios.post(`https://backend.ems.hiradentallab.com/api/timings/add/${userId}`, {
        userId,
        shiftStart,
        shiftEnd,
        breakStart: breakStart || null,
        breakEnd: breakEnd || null,
        totalHours: totalWorkHours,
        shift: calculateShift(shiftStart),
      });

      setAlertMessage(response.data.message);
      setShowAlert(true);
      setAlertVariant('success');
      setTimeout(() => navigate('/emps-schedule'), 3000);
    } catch (error) {
      console.error("Error adding timing data:", error);
      setAlertMessage(error.response?.data?.message || 'An error occurred while adding timing data.');
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  return (
    <EmpLayout>
      <div className="emp-timing-container">
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}
        <Form className="emp-timing-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="shiftStart">
                <Form.Label>Check-IN <span className="required-asterisk">*</span></Form.Label>
                <Form.Control
                  type="time"
                  name="shiftStart"
                  value={timingData.shiftStart}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="shiftEnd">
                <Form.Label>Check-Out <span className="required-asterisk">*</span></Form.Label>
                <Form.Control
                  type="time"
                  name="shiftEnd"
                  value={timingData.shiftEnd}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="breakStart">
                <Form.Label>Break-IN</Form.Label>
                <Form.Control
                  type="time"
                  name="breakStart"
                  value={timingData.breakStart}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="breakEnd">
                <Form.Label>Break-OUT</Form.Label>
                <Form.Control
                  type="time"
                  name="breakEnd"
                  value={timingData.breakEnd}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>
          <Button className="btn btn-primary mt-3" type="submit">Add</Button>
        </Form>
      </div>
      <div className="emp-shift-container">
        <Form.Group controlId="shift-select">
          <Form.Label>Selected Shift:</Form.Label>
          <Select
            value={shiftOptions.find(option => option.value === shift)}
            isDisabled
            options={shiftOptions}
            placeholder="--Shift--"
          />
        </Form.Group>
      </div>
    </EmpLayout>
  );
}
